import { useEffect } from "react";

const SITE_URL = "https://brandtobuilt.co.uk";

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

export const useSEO = ({ title, description, path = "/", noindex = false }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    const url = `${SITE_URL}${path}`;
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[property="og:url"]', "content", url);
    const robots = document.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
};

export const DEFAULT_SEO = {
  title: "BrandToBuilt | Your Business Online by Friday — Launch-Ready in 48 Hours",
  description: "BrandToBuilt gets UK small businesses launch-ready in 48 hours — website, logo, branding, domain, business email, Google Business & socials. Done for you, without the agency price tag. From £199.",
  path: "/",
};
